import styled, { css } from 'styled-components';

export default {
  Container: styled.div<{ offset: number; isTopPosition: boolean }>`
    position: absolute;
    bottom: ${({ offset }) => `${offset - 18}px`};
    right: 8px;
    /* ${({ isTopPosition }) => isTopPosition && 'transform: translateY(-100%)'}; */
    transition: 0.3s ease-out;
    z-index: 3;

    @media screen and (min-width: 768px) {
      right: 24px;
      bottom: ${(props) => props.offset + 24}px;
      transform: translateY(0);
    }

    @media screen and (max-width: 700px) {
      position: absolute;
      bottom: 130px;
    }

    ${(props) =>
      props.theme.isRtl &&
      css`
        right: unset;
        left: 8px;

        @media screen and (min-width: 768px) {
          right: unset;
          left: 24px;
        }
      `}
  `,
};
